/** @jsxImportSource @emotion/react */
import React, { FC, useState } from 'react';
import { useIntl } from 'react-intl';

import { StopConfirm } from '../stop-confirm/stop-confirm.component';
import { stopCharge } from '../../../../api/transactions/transactions.api';

import stopButtonStyles, { stoppingSpinnerStyles } from './stop-button.styles';
import { ITransaction } from '../../../../api/transactions/types';

type PropTypes = {
    guest: ITransaction;
};

export const StopButton: FC<PropTypes> = ({ guest }) => {
    const intl = useIntl();
    const [showConfirmButton, setShowConfirmButton] = useState(false);
    const [isStopping, setIsStopping] = useState(false);

    const onStopConfirm = (stop: boolean) => {
        setShowConfirmButton(false);
        if (stop) {
            setIsStopping(true);
            stopCharge(guest._id)
                .then(data => {
                    console.log(data);
                    // setShowConfirmButton(false);
                })
                .catch(error => {
                    console.error(error);
                    // setShowConfirmButton(false);
                    setIsStopping(false);
                });
        }
    };

    return (
        <>
            <button
                css={stopButtonStyles.powerStopButton}
                onClick={() => setShowConfirmButton(true)}
                disabled={showConfirmButton || isStopping}>
                {intl.formatMessage({ id: 'stopCharge' })}
                {isStopping && (
                    <div css={stoppingSpinnerStyles}>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                )}
            </button>
            {showConfirmButton && <StopConfirm onStopConfirm={onStopConfirm} />}
        </>
    );
};
